import { take, takeLatest } from "redux-saga/effects";

import { Creators as AllCreators, Types as AllTypes } from "../../actions";
import { fetchUsersAnalyticsSummaryForScormPackage } from "../../actions/analytics";
import { fetchCourse } from "../../actions/courses";
import { fetchScormPackage } from "../../actions/scormPackages";
import { fetchAllUsersForScormPackage } from "../../actions/users";

const Creators = (AllCreators as any).App.ScormPackageAnalytics;
const Types = (AllTypes as any)._APP._SCORM_PACKAGE_ANALYTICS;

export function* watchFetchScormPackageData() {
  yield takeLatest(
    Types.FETCH_SCORM_PACKAGE_DATA,
    fetchScormPackage({
      onFailure: Creators.handleFetchScormPackageDataFailure,
      onSuccess: Creators.handleFetchScormPackageDataSuccess,
    })
  );
}

export function* watchFetchCourseData() {
  yield takeLatest(
    Types.FETCH_COURSE_DATA,
    fetchCourse({
      onFailure: Creators.handleFetchCourseDataFailure,
      onSuccess: Creators.handleFetchCourseDataSuccess,
    })
  );
}

export function* watchFetchAllUsers() {
  yield takeLatest(
    Types.FETCH_ALL_USERS,
    fetchAllUsersForScormPackage({
      onFailure: Creators.handleFetchAllUsersFailure,
      onSuccess: Creators.handleFetchAllUsersSuccess,
    })
  );
}

export function* watchFetchUsersAnalytics() {
  yield takeLatest(
    Types.FETCH_USERS_ANALYTICS,
    fetchUsersAnalyticsSummaryForScormPackage({
      onFailure: Creators.handleFetchUsersAnalyticsFailure,
      onSuccess: Creators.handleFetchUsersAnalyticsSuccess,
    })
  );
}

export function* watchMount() {
  yield take(Types.MOUNT);
}

export function* watchUnmount() {
  yield take(Types.UNMOUNT);
}
